import { BaseClient } from '../client';
import { shopkeeperMock1 } from './shopkeeper.mocks';
import { TRevenda } from './shopkeeper.types';

export const getShopkeeperById = async ({ id }: { id: string }) => {
	if (process.env.NODE_ENV === 'development') {
		return shopkeeperMock1;
	}

	try {
		const response = await BaseClient.get<TRevenda>(`/Revendas/${id}`).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		console.error(error);
	}
};
